function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon feather-mouse-pointer",
  fill: "none",
  stroke: "#3c00dc",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 298",
  d: "M.5.5l10.6 25.455 3.77-11.085 11.085-3.77z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 299",
  d: "M15.5 15.5l9 9"
}));

function SvgCursorinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.455,
    height: 26.455,
    viewBox: "0 0 26.455 26.455"
  }, props), _ref);
}

export default SvgCursorinline;